var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-screen flex overflow-hidden bg-gray-200",
    class: {
      'bg-indigo-600': _vm.error
    },
    attrs: {
      "id": "mainLayout"
    }
  }, [_c('before-session-expire', {
    attrs: {
      "is-display-expiration-session-popup": _vm.isDisplayExpirationSessionPopup
    },
    on: {
      "close": function ($event) {
        _vm.isDisplayExpirationSessionPopup = false;
      }
    }
  }), _vm._v(" "), _c('cgv-popup', {
    attrs: {
      "data-to-show": _vm.waitToCGV
    }
  }), _vm._v(" "), _c('cgu-popup', {
    attrs: {
      "data-to-show": _vm.waitToCGU
    },
    on: {
      "accepted": function (e) {
        return _vm.startOnboarding(e);
      }
    }
  }), _vm._v(" "), false ? _c('onboarding', {
    ref: "onboarding",
    attrs: {
      "current-page": _vm.currentPage
    }
  }) : _vm._e(), _vm._v(" "), _vm.$freeParticulier() ? _c('onboarding2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$isMobile(),
      expression: "!$isMobile()"
    }],
    ref: "onboardingv2"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "leave-active-class": "duration-200"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "flex items-center z-50 fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "fixed inset-0 transition-opacity"
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-indigo-600 bg-opacity-85 flex items-center justify-center"
  }, [_c('div', [_c('span', {
    staticClass: "flex justify-center spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-1000",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.msgLongLoading,
      expression: "msgLongLoading"
    }],
    staticClass: "text-center text-base text-white animate-pulse"
  }, [_c('p', [_vm._v("Les données sont en cours de chargement.")]), _vm._v(" "), _c('p', [_vm._v("Cela peut-être long...Veuillez patienter.")])])])], 1)])])])], 1)]), _vm._v(" "), _c('menu-mobile', {
    staticClass: "xl:hidden",
    attrs: {
      "is-open": _vm.showMenu,
      "has-menu-neopass-form": _vm.menuNeopassForm,
      "has-menu-cartographie-collective": _vm.menuCartographieCollective,
      "has-menu-templates": _vm.menuTemplates,
      "has-menu-cartographie-individuelle": _vm.menuCartographieIndividuelle,
      "has-menu-curriculum-vitae": _vm.menuCvForm
    },
    on: {
      "close": function ($event) {
        _vm.showMenu = false;
      }
    }
  }), _vm._v(" "), !_vm.error && !_vm.$isGuest() ? _c('menu-desktop', {
    staticClass: "hidden xl:block"
  }) : _vm._e(), _vm._v(" "), _vm.menuNeopassForm ? _c('menu-formulaire', {
    staticClass: "hidden xl:block",
    attrs: {
      "id": "tour_menu_neopass"
    }
  }) : _vm._e(), _vm._v(" "), _vm.menuTemplates ? _c('menu-page-template', {
    staticClass: "hidden xl:block"
  }) : _vm._e(), _vm._v(" "), _vm.menuCartographieCollective ? _c('menu-cartographie-collective', {
    staticClass: "hidden xl:block"
  }) : _vm._e(), _vm._v(" "), _vm.menuCartographieIndividuelle ? _c('menu-cartographie-Individuelle', {
    staticClass: "hidden xl:block"
  }) : _vm._e(), _vm._v(" "), _vm.menuCvForm ? _c('menu-cv-formulaire', {
    staticClass: "hidden xl:block"
  }) : _vm._e(), _vm._v(" "), _vm.menuHelp ? _c('menu-help') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.waitToCGV && !_vm.waitToCGU,
      expression: "!waitToCGV && !waitToCGU"
    }],
    staticClass: "flex flex-col w-0 flex-1 overflow-hidden"
  }, [!_vm.error ? _c('navbar', {
    staticClass: "z-10",
    on: {
      "open": function ($event) {
        _vm.showMenu = true;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-1 relative overflow-y-auto lg:px-6 focus:outline-none md:py-6",
    attrs: {
      "id": "main-content",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "lg:pl-4 py-4 px-6 lg:px-10"
  }, [_c('router-view', {
    attrs: {
      "id": "main-router-view"
    }
  })], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }